import React from "react";
import DefaultFormLayout from "../../components/form/DefaultFormLayout/DefaultFormLayout";

import FieldSelector from "../../shared/form/components/FieldSelector";
import { useCreateUpdate } from "../../shared/form/hooks/useCreateUpdate";
import { CUEntityFormPropsType, UIFormInterface } from "../../shared/form/types/CRUDTypes";
import { CrudFormType } from "../../shared/form/types/FormTypes";
import { useLangLabels } from "../../shared/lang/services/useLangLabels";
import { useSessionContext } from "../session/store/sessionContext";
import { AnomalyInterface } from "./models/anomaliesTypes";
import {
  AnomalyCRUDDEpendencies,
  CreateAnomaly,
  DeleteAnomaly,
  UpdateAnomaly,
} from "./services/service.anomalies";
import { useAnomalyForm } from "./services/useAnomalyForm";

type props = CUEntityFormPropsType<AnomalyInterface> & { isDataUpdated?: boolean };

const CUAnomalyForm: React.FC<props> = ({ item, actionType, isDataUpdated }) => {
  const { tagFP } = useSessionContext();
  //DB
  const { action, resetStatus, status, error, message } = useCreateUpdate(
    {
      create: CreateAnomaly,
      update: UpdateAnomaly,
      delete: DeleteAnomaly,
    },
    actionType,
    AnomalyCRUDDEpendencies
  );

  //UI
  const { lang } = useLangLabels();

  const { uiModel, handleSubmit, resetForm } = useAnomalyForm(tagFP, item);

  const ui = (() => {
    const formName = lang.anomalies.plural;
    switch (actionType) {
      case CrudFormType.create:
        const create: UIFormInterface = {
          icon: "add",
          title: `${lang.actionTypes.create} ${formName.toLowerCase()}`,
          variant: "button",
          mode: "modal",
        };

        return create;

      case CrudFormType.update:
        const update: UIFormInterface = {
          icon: "edit",
          title: `${lang.actionTypes.update} ${formName.toLowerCase()}`,
          variant: "iconButton",
          mode: "content",
        };
        return update;
    }
  })();

  //Methods
  const submit = (data: AnomalyInterface) => {
    action(data);
  };

  const handleReset = () => {
    resetStatus();
    resetForm();
  };

  return (
    <DefaultFormLayout
      componentMode={ui.mode}
      buttonIcon={ui.icon}
      buttonVariant={ui.variant}
      buttonText={ui.title}
      popoverTitle={ui.title}
      {...{ queryStatus: status, error, alertStatusMessage: message }}
      buttonAction={handleSubmit(submit)}
      onClose={handleReset}
      resetForm={handleReset}
      isDataUpdated={isDataUpdated}
    >
      {uiModel.map((props, index) => (
        <FieldSelector key={index} fieldProps={props} />
      ))}
    </DefaultFormLayout>
  );
};

export default CUAnomalyForm;
